import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { BadgeCheckIcon, ChevronLeftIcon, ChevronRightIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eUXr1L2ENfAzbQbbbmot7u/ad3.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/7h1qPU2exeCiQA1AgFwB9M/5.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const results = [{
  label: 'TIENDA 1',
  amount: '$47.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: '$21.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: '$42.140.000',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroSlide, setHeroSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % results.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + results.length) % results.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % results.length);
  const goHeroPrev = () => setHeroSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goHeroNext = () => setHeroSlide(prev => (prev + 1) % resultImages.length);
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[10px] pb-[10px]" data-id="element-300" data-mp="25y51195u4kf2">
      <div className="max-w-6xl mx-auto" data-id="element-301" data-mp="1r98mct99w95h">
        <div className="text-center mb-12" data-id="element-302" data-mp="1r6clox61j6dc">
          <h2 className="md:text-5xl font-black text-white mb-4 pt-[0px] pb-[0px] text-[28px]" data-id="element-303" data-mp="1w70o0ezpz9mv">
            Quiénes somos y por qué podemos enseñarte?
          </h2>

          {/* Static image */}
          <div className="max-w-md mx-auto mb-8" data-id="element-304" data-mp="2owr1qmxfw9ig">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-305" data-mp="2ovfyco7wp3rv">
              <img src="https://cdn.magicpatterns.com/uploads/jpjQ2WmqW9RXQDsFySuAuF/Historias_Destacadas.png" alt="Brenda y Nasser - Quiénes somos" loading="lazy" className="w-full object-cover" data-id="element-306" data-mp="29xx456cglyd1" />
            </div>
          </div>

          <p className="text-xl max-w-3xl mx-auto text-[#D9D9D9] pt-[0px] pb-[0px] mt-[-20px] mb-[-20px]" data-id="element-307" data-mp="13jnzhza00rqx">
            Somos Nasser Khoder y Brenda H. Emprendores +10 años experiencia,
            Infoproductores, MKT, Creadores de Contenido, Marcas Personales y
            grandes comunidades❤️
          </p>

          <section aria-labelledby="autoridad-title" className="mx-auto mt-12 max-w-5xl rounded-3xl border border-white/15 bg-[#11131A] px-5 py-8 shadow-2xl md:px-10 md:py-10" data-id="element-308" data-mp="3qqj0otihogcq">
            <header className="mx-auto max-w-3xl" data-id="element-309" data-mp="2yy1u25hxuwsn">
              <p className="text-sm font-black uppercase tracking-[0.18em] text-[#FC9DFF]" data-id="element-310" data-mp="2u1um675zfb82">
                Confianza y tranquilidad
              </p>
              <h3 id="autoridad-title" className="mt-3 text-2xl font-black text-white md:text-4xl" data-id="element-311" data-mp="37ukfyxrr5kfq">
                Dominando Shopify, creado por personas reales
              </h3>
              <p className="mt-4 text-base leading-relaxed text-gray-300 md:text-lg" data-id="element-312" data-mp="2batqpt42lxt9">
                Nasser Khoder y Brenda Hormaechea crearon este programa para
                compartir una metodología clara, con experiencia, cercanía y
                transparencia en cada paso.
              </p>
            </header>

            <ul className="mt-7 grid gap-3 text-left sm:grid-cols-3" data-id="element-313" data-mp="2xwxm60o9rpxg">
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-314" data-mp="32ofddx0hqc58">
                <BadgeCheckIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-315" data-mp="37obhrxd3o5lb" />
                <span className="text-sm font-bold text-white" data-id="element-316" data-mp="3bnkcb4fys7hx">
                  Perfiles verificados
                </span>
              </li>
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-317" data-mp="3lo32si21am8t">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-318" data-mp="1mb8qg4r7688k" />
                <span className="text-sm font-bold text-white" data-id="element-319" data-mp="1rbmp4w6ws5tx">
                  +10 años de trayectoria
                </span>
              </li>
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-320" data-mp="1ez103ibpbao9">
                <UsersIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-321" data-mp="1a199qsqpfwm6" />
                <span className="text-sm font-bold text-white" data-id="element-322" data-mp="14za57fj8atnn">
                  +46.100 personas en Argentina y LATAM
                </span>
              </li>
            </ul>

            <div className="mt-8 grid justify-items-center gap-8 md:grid-cols-2" data-id="element-323" data-mp="1xqk33p5q6oqa">
              <figure className="w-full max-w-[300px]" data-id="element-324" data-mp="1spe81kolepdl">
                <div className="relative overflow-hidden rounded-[2.5rem] border-[7px] border-[#252832] bg-black p-1 shadow-[0_18px_45px_rgba(0,0,0,0.55)]" data-id="element-325" data-mp="1nruuyo3msin8">
                  <div className="absolute left-1/2 top-2 z-10 h-5 w-28 -translate-x-1/2 rounded-full bg-[#090A0E]" aria-hidden="true" data-id="element-326" data-mp="hctx2cv1pqe0" />
                  <img src="https://cdn.magicpatterns.com/uploads/hMPWdW3CzdFqBenYxkZP1m/WhatsApp_Image_2026-07-16_at_02.00.10.jpg" alt="Perfil verificado de Instagram de Brenda Hormaechea" loading="lazy" className="mt-5 w-full rounded-[2rem]" data-id="element-327" data-mp="30iwf9m4v3vqc" />
                </div>
                <figcaption className="mt-3 text-sm font-bold text-gray-200" data-id="element-328" data-mp="2gu5edfzgzj21">
                  Brenda Hormaechea — perfil verificado
                </figcaption>
              </figure>

              <figure className="w-full max-w-[300px]" data-id="element-329" data-mp="27u8ya2r5bsil">
                <div className="relative overflow-hidden rounded-[2.5rem] border-[7px] border-[#252832] bg-black p-1 shadow-[0_18px_45px_rgba(0,0,0,0.55)]" data-id="element-330" data-mp="27vjxrqdk6e3w">
                  <div className="absolute left-1/2 top-2 z-10 h-5 w-28 -translate-x-1/2 rounded-full bg-[#090A0E]" aria-hidden="true" data-id="element-331" data-mp="1xv9pmk6drwvl" />
                  <img src="https://cdn.magicpatterns.com/uploads/bZYZewXzgeQBSDFLFnfrV6/WhatsApp_Image_2026-07-16_at_02.00.10_(1).jpg" alt="Perfil verificado de Instagram de Nasser Khoder" loading="lazy" className="mt-5 w-full rounded-[2rem]" data-id="element-332" data-mp="1j82laxbehx5o" />
                </div>
                <figcaption className="mt-3 text-sm font-bold text-gray-200" data-id="element-333" data-mp="227ow1i8dixcn">
                  Nasser Khoder — perfil verificado
                </figcaption>
              </figure>
            </div>
          </section>

          <h3 className="text-2xl md:text-4xl font-black text-white mt-10 mb-2" data-id="element-334" data-mp="2bx8cyicj0h4v">
            Y podemos enseñarte porque tenemos{' '}
            <span className="underline decoration-4 decoration-yellow-400" data-id="element-335" data-mp="26zq2gniv1tur">
              RESULTADOS
            </span>
          </h3>
          <p className="text-lg md:text-xl text-[#D9D9D9] mb-8 pt-[20px] pb-[20px]" data-id="element-336" data-mp="2ltl4b9klmiwg">
            Esto es lo que facturaron nuestras tiendas los últimos 6 meses👇
          </p>
        </div>

        {/* Carousel */}
        <div className="max-w-lg mx-auto mt-[-35px] mb-[-35px]" data-id="element-337" data-mp="16jd3e9qmf36o">
          <div className="bg-gray-800 rounded-2xl overflow-hidden animate-neon-violet" data-id="element-338" data-mp="16hijmyr35h46">
            {/* Image carousel */}
            <div className="relative" data-id="element-339" data-mp="1bglreqyga1fu">
              <div className="overflow-hidden" data-id="element-340" data-mp="1ghsuicpnecg6">
                <div className="flex transition-transform duration-700 ease-in-out" style={{
                transform: `translateX(-${currentSlide * 100}%)`
              }} data-id="element-341" data-mp="1gfgfa7b9yg6t">
                  {results.map((result, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-342" data-mp="spvl0s9o7wi8" data-mpi={index}>
                      <div className="p-4 text-center" data-id="element-343" data-mp="xjgm4t6k96ln">
                        <span className="text-sm font-bold text-green-400 tracking-widest" data-id="element-344" data-mp="3j7pn120vrg">
                          {result.label}
                        </span>
                      </div>
                      <div className="px-4" data-id="element-345" data-mp="2icnielogmbnq">
                        <div className="overflow-hidden rounded-lg" style={{
                      height: '280px'
                    }} data-id="element-346" data-mp="2ibchquqb9k0u">
                          <img src={result.image} alt={`${result.label} - Resultados de ventas`} loading="lazy" className="w-full h-full object-cover object-top" data-id="element-347" data-mp="29e26389kzsve" />
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Navigation arrows */}
              <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-348" data-mp="1lnxzcs13jd06">
                <ChevronLeftIcon className="w-5 h-5" data-id="element-349" data-mp="1bqjln06k52bk" />
              </button>
              <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-350" data-mp="grdgiyg9ibra">
                <ChevronRightIcon className="w-5 h-5" data-id="element-351" data-mp="pn31j6dst445" />
              </button>
            </div>

            {/* Footer - shows current slide's data */}
            <div className="p-6 text-center" data-id="element-352" data-mp="3u0hxmwotb7rt">
              <p className="text-3xl md:text-4xl font-black text-green-400 mb-1 transition-all duration-500" data-id="element-353" data-mp="3u1b7i6j2ide6">
                {results[currentSlide].amount}
              </p>
              <p className="text-gray-400 font-semibold text-sm" data-id="element-354" data-mp="6w23qloezem6">
                PESOS ARGENTINOS EN VENTAS
              </p>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-355" data-mp="1i8mdjq6867k6">
            {results.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-356" data-mp="1da1gu0q6m60h" data-mpi={index} />)}
          </div>
        </div>

        <div className="text-center pt-[10px] pb-[10px]" data-id="element-357" data-mp="1bvryk6qjgs4o">
          <div className="inline-block px-8 py-3 rounded-full font-black text-[#FFFFFF] bg-[#9C16A3] animate-neon-violet text-[19px] mt-[60px] mb-[60px] pt-[12px] pb-[12px]" data-id="element-358" data-mp="1gttgupg54nf3">
            Si aplicas, en semanas podes estar generando MÍNIMO $1.500 - $3.000
            usd💰
          </div>
        </div>
      </div>
    </section>;
}